export const INVALID_CREDENTIAL = 'INVALID_CREDENTIAL';
export const INVALID_EMAIL = 'INVALID_EMAIL';
export const INVALID_USER_OR_CREDENTIALS = 'INVALID_USER_OR_CREDENTIALS';
export const INVALID_RETURN_URL = 'INVALID_RETURN_URL';
export const SESSION_COOKIE_DOES_NOT_EXIST = 'SESSION_COOKIE_DOES_NOT_EXIST';
export const COOKIE_NOT_DEFINED = 'COOKIE_NOT_DEFINED';
export const USER_CREATED = 'USER_CREATED';
export const USER_DELETED = 'USER_DELETED';
export const INVALID_COOKIE = 'INVALID_COOKIE';
export const PASSWORD_NOT_UNIQUE = 'PASSWORD_NOT_UNIQUE';
export const PASSWORD_MIN_LENGTH = 'PASSWORD_MIN_LENGTH';
export const USER_CREDENTIAL_NOT_CHECKED = 'USER_CREDENTIAL_NOT_CHECKED';
export const USER_NAME_REQUIRED = 'USER_NAME_REQUIRED';
export const INVALID_2FA_CODE = 'INCORRECT_2FA_CODE';
export const EXPIRED_2FA_CODE = 'EXPIRED_2FA_CODE';
export const EXPIRED_EMAIL_CODE = 'EXPIRED_EMAIL_CODE';
export const TWO_FA_REGISTRATION_FAILED = '2FA_REGISTRATION_FAILED';
export const MAXIMUM_OTP_REQUESTS = 'MAXIMUM_OTP_REQUESTS';
export const LINK_EXPIRED = 'LINK_EXPIRED';
export const MAXIMUM_2FA_RESET_ATTEMPTS_REACHED = 'MAXIMUM_2FA_RESET_ATTEMPTS_REACHED';
export const USER_LOCKED = 'USER_LOCKED';
export const USER_LOCKED_NOW = 'USER_LOCKED_NOW';
export const USER_BLOCKED = 'USER_BLOCKED';
export const IDP_INITIATED_SSO_NOT_ALLOWED = 'IDP_INITIATED_SSO_NOT_ALLOWED';
export const EXTERNAL_PROVIDER_MISMATCH = 'EXTERNAL_PROVIDER_MISMATCH';
export const EXTERNAL_AUTHENTICATION_ERROR = 'EXTERNAL_AUTHENTICATION_ERROR';
